import EmptyImage from 'shared/images/empty-image.webp'
import GhostImage from 'shared/images/empty-image.webp'
import { Carousel } from 'shared/ui/carousel'
import { GalleryImages } from 'shared/ui/image-carousel/styles.ts'

import s from './styles.module.scss'

interface Props {
  images: GalleryImages[]
  onClick?: () => void
}

export const ImageCarousel = ({ images, onClick }: Props) => {
  return (
    <div
      className={s.carousel}
      onClick={Boolean(images?.length) ? onClick : undefined}
    >
      <Carousel
        showCounter
        dotsVariant="custom"
        images={images}
        errorImage={EmptyImage}
        emptyStateImg={GhostImage}
      />
    </div>
  )
}
